"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPlayerRow = void 0;
var vue_1 = require("vue");
exports.SelectPlayerRow = vue_1.default.component('select-player-row', {
    props: {
        player: {
            type: Object,
        },
    },
    methods: {},
    data: function () {
        return {};
    },
    template: '<span>{{player === undefined ? "" : player.name}}</span>',
});
//# sourceMappingURL=SelectPlayerRow.js.map